<template>
  <div class="report-check">
    <div class="data-content">
      <div style="width: 100%; display: flex;">
        <div class="report-content">
          <Table stripe border highlight-row :columns="columns" :data="changeDataList"
            @on-selection-change="selected" :height="tableHeight">
            <template slot-scope="{ row, index }" slot="title">
              <span>{{ row.title }}</span>
            </template>

            <template slot-scope="{ row, index }" slot="new_user_count">
              <span>{{ row.new_user_count }}</span><span style="color: red; font-weight: 700;" v-if="row.new_user_count_change == 1" >↑</span><span style="color: lightgreen; font-weight: 700;" v-if="row.new_user_count_change == 2">↓</span>
            </template>

            <template slot-scope="{ row, index }" slot="income_rmb">
              <span>{{ row.income_rmb }}</span><span style="color: red; font-weight: 700;" v-if="row.income_rmb_change == 1" >↑</span><span style="color: lightgreen; font-weight: 700;" v-if="row.income_rmb_change == 2">↓</span>
            </template>

            <template slot-scope="{ row, index }" slot="active_user_count">
              <span>{{ row.active_user_count }}</span><span style="color: red; font-weight: 700;" v-if="row.active_user_count_change == 1" >↑</span><span style="color: lightgreen; font-weight: 700;" v-if="row.active_user_count_change == 2">↓</span>
            </template>

            <template slot-scope="{ row, index }" slot="puc_d1">
              <span>{{ row.puc_d1 }}</span>
            </template>
            <template slot-scope="{ row, index }" slot="income_d1">
              <span>{{ row.income_d1 }}</span>
            </template>
            
            <template slot-scope="{ row, index }" slot="pay_rate1">
              <span>{{ row.pay_rate1 }}</span>
            </template>
            <template slot-scope="{ row, index }" slot="arpu1">
              <span>{{ row.arpu1 }}</span>
            </template>
            <template slot-scope="{ row, index }" slot="arppu1">
              <span>{{ row.arppu1 }}</span>
            </template>
            
            <template slot-scope="{ row, index }" slot="puc_d7">
              <span>{{ row.puc_d7 }}</span>
            </template>
            <template slot-scope="{ row, index }" slot="income_d7">
              <span>{{ row.income_d7 }}</span>
            </template>
            <template slot-scope="{ row, index }" slot="pay_rate7">
              <span>{{ row.pay_rate7 }}</span>
            </template>
            <template slot-scope="{ row, index }" slot="arpu7">
              <span>{{ row.arpu7 }}</span>
            </template>
            <template slot-scope="{ row, index }" slot="arppu7">
              <span>{{ row.arppu7 }}</span>
            </template>
          </Table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import apis from "../../http/api";

  export default {
    name: "AnalyseList",
    components: {},
    watch: {},
    data() {
      return {
        tableHeight: 400,
        dataList: [],
        columns: [{
            title: '收入名称',
            slot: 'title',
            align: 'center',
            fixed: 'left',
            width: 160
          },
          {
            title: '每日收入/日',
            slot: 'income_rmb',
            align: 'center',
            width: 160
          },
          {
            title: '活跃人数/日',
            slot: 'active_user_count',
            align: 'center',
            width: 160
          },
          {
            title: '新注册人数/日',
            slot: 'new_user_count',
            align: 'center',
            width: 160
          },
          {
            title: '首日（新用户）',
            align: 'center',
            children: [{
                title: '人数/日',
                slot: 'puc_d1',
                align: 'center',
                width: 90
              },
              {
                title: '金额/日',
                slot: 'income_d1',
                align: 'center',
                width: 90
              },
              {
                title: '付费率',
                slot: 'pay_rate1',
                align: 'center',
                width: 90
              },
              {
                title: 'arpu',
                slot: 'arpu1',
                align: 'center',
                width: 90
              },
              {
                title: 'arppu',
                slot: 'arppu1',
                align: 'center',
                width: 90
              }
            ]
          },
          {
            title: '7日（新用户）',
            align: 'center',
            children: [{
                title: '人数/日',
                slot: 'puc_d7',
                align: 'center',
                width: 90
              },
              {
                title: '金额/日',
                slot: 'income_d7',
                align: 'center',
                width: 90
              },
              {
                title: '付费率',
                slot: 'pay_rate7',
                align: 'center',
                width: 90
              },
              {
                title: 'arpu',
                slot: 'arpu7',
                align: 'center',
                width: 90
              },
              {
                title: 'arppu',
                slot: 'arppu7',
                align: 'center',
                width: 90
              }
            ]
          }
        ],
      }
    },
    created() {
      this.tableHeight = window.innerHeight - 180
      window.addEventListener('resize', this.handleResize);
      this.getData()
    },
    methods: {
      handleResize() {
        this.tableHeight = window.innerHeight - 180
      },
      deviceTypeChanged(options) {
        this.getData()
      },
      getData() {
        let params = {};
        apis.user_analyse_income_recently_analysis(params).then(res => {
          const {
            data,
            errCode,
            msg
          } = res;
          if (errCode === 0) {
            this.dataList = data;
          } else {
            this.$Message.error(msg);
            this.dataList = null
          }
        }).catch(err => {
          this.$Message.error('接口异常,请联系管理员');
          this.dataList = []
        })
      },
      selected(selecttion) {
        console.log(selecttion.id)
      },
      compareCount(val1,val2){
        var val1New = parseFloat(val1)
        var val2New = parseFloat(val2)
        if(val1New == val2New){
          return 0;
        }else if(val1New > val2New){
          return 1
        }else {
          return 2
        }
      }
    },
    computed: {
      changeDataList() {
        return this.dataList.map(item => {
          
          for(var i=0; i<this.dataList.length;i++){
            switch(item.title){
              case "最近7天工作日":
                if(this.dataList[i].title == "本月工作日"){
                  item['income_rmb_change'] = this.compareCount(item.income_rmb,this.dataList[i].income_rmb)
                  item['active_user_count_change'] = this.compareCount(item.active_user_count,this.dataList[i].active_user_count)
                  item['new_user_count_change'] = this.compareCount(item.new_user_count,this.dataList[i].new_user_count)
                }
                break
              case "本月工作日":
                if(this.dataList[i].title == "上月工作日"){
                  item['income_rmb_change'] = this.compareCount(item.income_rmb,this.dataList[i].income_rmb)
                  item['active_user_count_change'] = this.compareCount(item.active_user_count,this.dataList[i].active_user_count)
                  item['new_user_count_change'] = this.compareCount(item.new_user_count,this.dataList[i].new_user_count)
                }
                break
              case "最近7天节假日":
                if(this.dataList[i].title == "本月节假日"){
                  item['income_rmb_change'] = this.compareCount(item.income_rmb,this.dataList[i].income_rmb)
                  item['active_user_count_change'] = this.compareCount(item.active_user_count,this.dataList[i].active_user_count)
                  item['new_user_count_change'] = this.compareCount(item.new_user_count,this.dataList[i].new_user_count)
                }
                break
              case "本月节假日":
                if(this.dataList[i].title == "上月节假日"){
                  item['income_rmb_change'] = this.compareCount(item.income_rmb,this.dataList[i].income_rmb)
                  item['active_user_count_change'] = this.compareCount(item.active_user_count,this.dataList[i].active_user_count)
                  item['new_user_count_change'] = this.compareCount(item.new_user_count,this.dataList[i].new_user_count)
                }
                break
            }
          }
          return item
        })
      }
    },
    filters: {}
  }
</script>

<style scoped>
  .report-check {
    margin: 10px;
  }

  .clickable-span {
    color: #1890ff;
    text-decoration: underline;
    cursor: pointer;
  }

  .text-center {
    text-align: center;
  }

  .table-head {
    display: flex;
    justify-content: space-between;
    padding-bottom: 5px;
  }

  .table-title {
    align-self: center;
  }

  .modal1-div {
    margin-bottom: 10px;
  }

  .info-pop {
    white-space: pre-wrap;
  }

  .avatar {
    float: left;
    width: 50px;
    margin-top: 20px;
    margin-right: 15px;
  }

  .img-avatar {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    border: 2px solid lightgray;
  }

  .img-avatar-preview {
    width: 400px;
    height: 400px;
  }

  .report-content {
    float: left;
    width: 100%;
    margin-top: 20px;
    margin-bottom: 20px;
    margin-left: 20px;
  }

  .report-table-td-title {
    width: 95px;
    color: #333333;
    /* font-size: 18px; */
    padding-left: 5px;
    padding-right: 5px;
    vertical-align: top;
  }

  .report-table-td-content {
    width: 360px;
    color: #333333;
    /* font-size: 18px; */
    padding-left: 5px;
    padding-right: 5px;
  }

  table,
  th,
  td {
    border: 2px solid transparent;
    border-collapse: collapse;
  }

  table,
  td {
    height: auto;
  }

  .report-button {
    font-size: 12px;
    margin-left: 5px;
    width: 100px;
    height: 22px;
    margin-right: 5px;
  }

  .report-button-other {
    font-size: 12px;
    margin-left: 5px;
    width: 100px;
    height: 22px;
    margin-right: 5px;
    background-color: #fff;
    /* border-color: #f90; */
    border: 0.5px solid #ff9900;
    color: #f90;
  }
</style>